import axios from 'axios'

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1']
if (process.env.REACT_APP_LOCAL_IP) {
  LOCAL_HOSTNAMES.push(process.env.REACT_APP_LOCAL_IP)
}

const isLocalhost = LOCAL_HOSTNAMES.includes(window.location.hostname)

const API_URL =
  process.env.REACT_APP_API_URL ||
  (isLocalhost
    ? 'http://localhost:8090/api'
    : process.env.REACT_APP_API_URL_PROD ||
      'https://tribulum.redirectme.net/api')

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  withCredentials: true, // envía cookies httpOnly en cada petición
  headers: {
    'Content-Type': 'application/json',
  },
})

let refreshPromise = null

const refreshAccessToken = async () => {
  // Las cookies se envían automáticamente — no necesitamos extraer ni pasar tokens
  const response = await apiClient.post('/auth/refresh')
  return response.data
}

if (process.env.NODE_ENV !== 'production') {
  apiClient.interceptors.request.use((config) => {
    console.log(`[API] -> ${config.method?.toUpperCase()} ${config.url}`, {
      data: config.data,
    })
    return config
  })
}

apiClient.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(
        `[API] <- ${response.config.method?.toUpperCase()} ${response.config.url}`,
        { status: response.status },
      )
    }
    return response
  },
  async (error) => {
    const originalRequest = error.config

    if (process.env.NODE_ENV !== 'production') {
      console.error(
        `[API] Error en ${originalRequest?.method?.toUpperCase()} ${originalRequest?.url}:`,
        { status: error.response?.status },
      )
    }

    // Reintentar una vez con refresh token si recibimos 401 (no en rutas de auth)
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/auth/')
    ) {
      originalRequest._retry = true
      try {
        if (!refreshPromise) {
          refreshPromise = refreshAccessToken().finally(() => {
            refreshPromise = null
          })
        }
        await refreshPromise
        return apiClient(originalRequest)
      } catch (refreshError) {
        console.error('[API] Error al refrescar token:', refreshError)
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login'
        }
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  },
)

// Exportaciones de compatibilidad (ya no hacen nada pero evitan romper importaciones existentes)
export const setRememberCache = () => {}
export const invalidateTokenCache = () => {}

export default apiClient
